import { create } from 'zustand';

interface MessagesStore {
  openWithUserId: string | null;
  openWithContext: { type: 'request' | 'booking'; contextId: string; participantId: string } | null;
  setOpenWithUserId: (userId: string | null) => void;
  setOpenWithContext: (ctx: MessagesStore['openWithContext']) => void;
  closeMessages: () => void;
}

export const useMessagesStore = create<MessagesStore>((set) => ({
  openWithUserId: null,
  openWithContext: null,
  setOpenWithUserId: (userId) => set({ openWithUserId: userId, openWithContext: null }),
  setOpenWithContext: (ctx) => set({ openWithContext: ctx, openWithUserId: null }),
  closeMessages: () => set({ openWithUserId: null, openWithContext: null }),
}));
